import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-layout-community',
  templateUrl: './layout-community.component.html',
  styleUrls: ['./layout-community.component.sass']
})
export class LayoutCommunityComponent implements OnInit {
  public tablesTranslate: any;
  constructor(private _translation: TranslationService) { }

  ngOnInit() {
    this.initializeDatablesTranslation();
  }

  initializeDatablesTranslation(): void {
    this._translation.getDataTableTranslation()
      .subscribe(dataTableTranslation => {
        this.tablesTranslate = dataTableTranslation;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/layout-community/layout-community.component.ts